import Reflux from 'reflux';

export default Reflux.createActions({
    "inputChange": {sync: true},
    "getRetIslrs": {},
    "getRetIslr": {},
    "postRetIslr": {},
    "putRetIslr": {},
    "deleteRetIslr": {},
    "apiFilter": {},
    "download": {},
    "filter": {sync:true},
    "getReport": {},
    "sendMail": {}
});


/** WEBPACK FOOTER **
 ** ./app-react/reflux/RetIslrActions.js
 **/